import React from 'react'

import styled from 'styled-components'

import { theme } from 'app/match/applicationReportPDF/assets/theme'
import * as phoneNumberHelpers from 'app/utils/phonenumber/helpers'

import { Box, Flex } from '.'

const StyledName = styled(Box)`
  font-size: ${({ theme }) => theme.fontSizes[5]}px;
  margin-bottom: ${({ theme }) => theme.space[3]}px;
`

const StyledContactNumAndEmail = styled(Flex)`
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  align-items: center;
  @media screen and (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const StyledCircleDivider = styled(Box)`
  height: ${({ theme }) => theme.space[3]}px;
  width: ${({ theme }) => theme.space[3]}px;
  background-color: ${({ theme }) => theme.colors.gray600};
  border-radius: ${({ theme }) => theme.radii[7]};
  margin-right: ${({ theme }) => theme.space[3]}px;
  @media screen and (max-width: 576px) {
    display: none;
  }
`

const StyledContactNum = styled(Box)`
  min-width: 100px;
`

const StyledEmail = styled(Box)`
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

function ContactDetails({ name = '', contactNumber = '', email = '' }) {
  const formattedMobileNumber =
    phoneNumberHelpers.formatPhoneNumber(contactNumber)
  return (
    <Box>
      <StyledName>{name}</StyledName>
      <StyledContactNumAndEmail>
        <StyledContactNum mr={theme.baseSpace + 'px'}>
          {formattedMobileNumber}
        </StyledContactNum>
        {formattedMobileNumber && email && <StyledCircleDivider />}
        <StyledEmail>{email}</StyledEmail>
      </StyledContactNumAndEmail>
    </Box>
  )
}

export default ContactDetails
